import { Button, Card, Typography, IconButton, Popover, Box } from '@mui/material';
import ArgonBox from "components/ArgonBox";
import React, { useEffect, useMemo, useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { useAuth } from "context/AuthContext";
import { useUser } from "context/UserContext";
import EditIcon from '@mui/icons-material/Edit';
import NotificationsOutlined from '@mui/icons-material/NotificationsOutlined';
import { PerfilSkeleton } from "components/SkeletonLoader";

const especialidadesData = [
  { label: "Adolescentes", value: "adolescentes" },
  { label: "Adulto Mayor", value: "adulto-mayor" },
  { label: "Agorafobia", value: "agorafobia" },
  { label: "Análisis de Sueños", value: "analisis-de-suenos" },
  { label: "Anorexia", value: "anorexia" },
  { label: "Ansiedad", value: "ansiedad" },
  { label: "Arteterapia", value: "arteterapia" },
  { label: "Asperger", value: "asperger" },
  { label: "Ataques de Pánico", value: "ataques-de-panico" },
  { label: "Autismo", value: "autismo" },
  { label: "Biodescodificacion", value: "biodescodificacion" },
  { label: "Brainspotting", value: "brainspotting" },
  { label: "Bullying", value: "bullying" },
  { label: "Coaching", value: "coaching" },
  { label: "Counseling", value: "counseling" },
  { label: "Cristiano", value: "cristiano" },
  { label: "Dependencia Emocional", value: "dependencia-emocional" },
  { label: "Deportivo", value: "deportivo" },
  { label: "Depresión", value: "depresion" },
  { label: "Depresión en adolescentes", value: "depresion-en-adolescentes" },
  { label: "Depresión posparto", value: "depresion-posparto" },
  { label: "Duelo", value: "duelo" },
  { label: "EMDR", value: "emdr" },
  { label: "En español", value: "en-espanol" },
  { label: "En francés", value: "en-frances" },
  { label: "En inglés", value: "en-ingles" },
  { label: "En italiano", value: "en-italiano" },
  { label: "En línea", value: "en-linea" },
  { label: "En portugués", value: "en-portugues" },
  { label: "Enfermedad Crónica", value: "enfermedad-cronica" },
  { label: "Especialista en Abuso Infantil", value: "especialista-en-abuso-infantil" },
  { label: "Especialista en Adicciones", value: "especialista-en-adicciones" },
  { label: "Especialista en Alimentación", value: "especialista-en-alimentacion" },
  { label: "Especialista en Ansiedad", value: "especialista-en-ansiedad" },
  { label: "Especialista en Ataques de Pánico", value: "especialista-en-ataques-de-panico" },
  { label: "Especialista en Bipolaridad", value: "especialista-en-bipolaridad" },
  { label: "Especialista en burnout", value: "especialista-en-burnout" },
  { label: "Especialista en Cognitivo Conductual", value: "especialista-en-cognitivo-conductual" },
  { label: "Especialista en Depresión", value: "especialista-en-depresion" },
  { label: "Especialista en Duelo", value: "especialista-en-duelo" },
  { label: "Especialista en Fobia Social", value: "especialista-en-fobia-social" },
  { label: "Especialista en Narcisismo", value: "especialista-en-narcisismo" },
  { label: "Especialista en Psicoanálisis", value: "especialista-en-psicoanalisis" },
  { label: "Especialista en Separaciones", value: "especialista-en-separaciones" },
  { label: "Especialista en Sexología", value: "especialista-en-sexologia" },
  { label: "Especialista en TCA", value: "especialista-en-tca" },
  { label: "Especialista en TDAH", value: "especialista-en-tdah" },
  { label: "Especialista en TOC", value: "especialista-en-toc" },
  { label: "Especialista en Trastornos Alimenticios", value: "especialista-en-trastornos-alimenticios" },
  { label: "Especialista en Traumas", value: "especialista-en-traumas" },
  { label: "Estrés", value: "estres" },
  { label: "Estrés Laboral", value: "estres-laboral" },
  { label: "Estrés Postraumático", value: "estres-postraumatico" },
  { label: "Familiar", value: "familiar" },
  { label: "Forense", value: "forense" },
  { label: "Gestalt", value: "gestalt" },

  { label: "Hipnósis", value: "hipnosis" },
  { label: "Infantil", value: "infantil" },
  { label: "Insomnio", value: "insomnio" },
  { label: "Judicial", value: "judicial" },
  { label: "Junguiano", value: "junguiano" },
  { label: "Laboral", value: "laboral" },
  { label: "LGBTIQ+", value: "lgbtiq" },
  { label: "Logoterapia", value: "logoterapia" },
  { label: "Ludopatía", value: "ludopatia" },
  { label: "Meditación", value: "meditacion" },
  { label: "Mindfulness", value: "mindfulness" },
  { label: "Mitomanía", value: "mitomania" },
  { label: "Neuropsicología", value: "neuropsicologia" },
  { label: "Online", value: "online" },
  { label: "Para empresas", value: "para-empresas" },
  { label: "Para estudiantes universitarios", value: "para-estudiantes-universitarios" },
  { label: "Para sordos", value: "para-sordos" },
  { label: "Perinatal", value: "perinatal" },
  { label: "Perspectiva de Género", value: "perspectiva-de-genero" },
  { label: "Psicoanálisis", value: "psicoanalisis" },
  { label: "Psicoanalista", value: "psicoanalista" },
  { label: "Psicodiagnóstico", value: "psicodiagnostico" },
  { label: "Psicología Médica", value: "psicologia-medica" },
  { label: "Psicología Positiva", value: "psicologia-positiva" },
  { label: "Psiconeuroinmunoendocrinología", value: "psiconeuroinmunoendocrinologia" },
  { label: "Psicosomático", value: "psicosomatico" },
  { label: "Salud Mental", value: "salud-mental" },
  { label: "Sentido de la Vida", value: "sentido-de-la-vida" },
  { label: "Sexología", value: "sexologia" },
  { label: "Suicidio", value: "suicidio" },
  { label: "TDAH", value: "tdah" },
  { label: "TEPT", value: "tept" },
  { label: "Terapia Cognitivo Conductual", value: "terapia-cognitivo-conductual" },
  { label: "Terapia DBT", value: "terapia-dbt" },
  { label: "Terapia de Pareja", value: "terapia-de-pareja" },
  { label: "Terapia EMDR", value: "terapia-emdr" },
  { label: "Terapia Sistémica", value: "terapia-sistemica" },
  { label: "Terapia Vocacional", value: "terapia-vocacional" },
  { label: "Terapias Alternativas", value: "terapias-alternativas" },
  { label: "TOC", value: "toc" },
  { label: "Transpersonal", value: "transpersonal" },
  { label: "Trastorno Límite de la Personalidad", value: "trastorno-limite-de-la-personalidad" },
  { label: "Trastornos Alimenticios", value: "trastornos-alimenticios" },
  { label: "Trastornos de Personalidad", value: "trastornos-de-personalidad" },
  { label: "Violencia de Género", value: "violencia-de-genero" },
];

const restriccionesPorBanco = (banco) => {
  switch (banco) {
    case "BROU":
      return {
        maxLength: 14,
        minLength: 14,
        pattern: /^[0-9]{14}$/,
        helperText: "Debe tener 14 dígitos. Ej: 00099299700002"
      };
    case "Banco Hipotecario del Uruguay":
      return {
        maxLength: 10,
        minLength: 10,
        pattern: /^[0-9]{10}$/,
        helperText: "Debe tener 10 dígitos. Ej: 0123456789"
      };
    case "Citibank":
      return {
        maxLength: 10,
        minLength: 10,
        pattern: /^[0-9]{10}$/,
        helperText: "Debe tener 10 dígitos, rellenando con ceros a la izquierda. Ej: 0061436006"
      };
    case "Itau":
      return {
        maxLength: 7,
        minLength: 7,
        pattern: /^[0-9]{7}$/,
        helperText: "Debe tener 7 dígitos, rellenando con ceros a la izquierda. Ej: 3190373"
      };
    case "Scotiabank":
      return {
        maxLength: 10,
        minLength: 7,
        pattern: /^[0-9]{7,10}$/,
        helperText: "Puede tener 7 o 10 dígitos, rellenando con ceros a la izquierda."
      };
    case "Santander":
      return {
        maxLength: 16,
        minLength: 12,
        pattern: /^([0-9]{12}|[0-9]{16})$/,
        helperText: "Debe tener 16 dígitos: 4 sucursal + 12 cuenta (ej: 0001000000000001)"
      };
    case "Banco de la Nación Argentina":
      return {
        maxLength: 12,
        minLength: 12,
        pattern: /^[0-9]{12}$/,
        helperText: "Debe tener 12 dígitos, rellenando con ceros a la izquierda."
      };
    case "BBVA":
      return {
        maxLength: 9,
        minLength: 1,
        pattern: /^[0-9]{1,9}$/,
        helperText: "Hasta 9 dígitos, solo números. Ej: 20237345"
      };
    case "HSBC":
      return {
        maxLength: 10,
        minLength: 10,
        pattern: /^[0-9]{10}$/,
        helperText: "Debe tener 10 dígitos, rellenando con ceros a la izquierda."
      };
    case "Heritage":
      return {
        maxLength: 9,
        minLength: 9,
        pattern: /^[0-9]{9}$/,
        helperText: "Debe tener 9 dígitos, rellenando con ceros a la izquierda."
      };
    case "PREX":
      return {
        maxLength: 8,
        minLength: 8,
        pattern: /^[0-9]{8}$/,
        helperText: "Debe tener 8 dígitos, rellenando con ceros a la izquierda."
      };
    case "MIDINERO":
    case "Mi Dinero":
      return {
        maxLength: 7,
        minLength: 7,
        pattern: /^[0-9]{7}$/,
        helperText: "Debe tener 7 dígitos. Ej: 3259658"
      };
    case "OCA Blue":
      return {
        maxLength: 7,
        minLength: 7,
        pattern: /^[0-9]{7}$/,
        helperText: "Debe tener 7 dígitos, rellenando con ceros a la izquierda."
      };
    case "BAPRO":
      return {
        maxLength: 7,
        minLength: 7,
        pattern: /^[0-9]{7}$/,
        helperText: "Debe tener 7 dígitos. Ej: 5674536"
      };
    default:
      return {
        maxLength: 20,
        minLength: 1,
        pattern: /^[0-9]+$/,
        helperText: "Ingrese el número de cuenta"
      };
  }
};

const bankNameToCode = {
  "Itau": "113",
  "BROU": "001",
  "Bandes": "110",
  "BBVA": "153",
  "Scotiabank": "128",
  "Santander": "137",
  "MIDINERO": "6917",
  "OCA Blue": "815",
  "PREX": "452",
  "Banco Hipotecario del Uruguay": "011",
  "Citibank": "021",
  "HSBC": "029",
  "Heritage": "031",
  "Banco de la Nación Argentina": "011",
};

const Perfil = () => {
  const { user, loading: authLoading, getToken } = useAuth();
  const {
    descripcion: descripcionContext,
    banco: bancoContext,
    profesion: profesionContext,
    numeroCuenta: numeroCuentaContext,
    numeroSucursal: numeroSucursalContext,
    labels: labelsContext,
    nombre: nombreContext,
    apellido: apellidoContext,
    email: emailContext,
    celular: celularContext,
    imagen: imagenContext,
    genero: generoContext,
    honorarios: honorariosContext,
    loading: userLoading,
    isDataLoaded
  } = useUser();
  const navigate = useNavigate();
  const [descripcion, setDescripcion] = useState("");
  const [banco, setBanco] = useState("");
  const [profesion, setProfesion] = useState("");
  const [numeroCuenta, setNumeroCuenta] = useState("");
  const [numeroSucursal, setNumeroSucursal] = useState("");
  const [mostrarSucursal, setMostrarSucursal] = useState(false);
  const [, setMensaje] = useState("");
  const [, setIsMobile] = useState(window.innerWidth < 1200);
  const [especialidades, setEspecialidades] = useState([]);
  const profesionalId = localStorage.getItem('id');
  const [notificationsAnchorEl, setNotificationsAnchorEl] = useState(null);

  // Estados para validación de cuenta bancaria
  const [cuentaBancariaValida, setCuentaBancariaValida] = useState(null);
  const [, setMensajeCuentaBancaria] = useState("");

  // Estados para datos del profesional (para la vista previa)
  const [profesionalData, setProfesionalData] = useState({
    nombre: "",
    apellido: "",
    email: "",
    celular: "",
    imagen: "",
    genero: "",
    honorarios: 0
  });

  // Estados para cambio de foto de perfil
  const [isUploadingImage, setIsUploadingImage] = useState(false);
  const [showCropModal, setShowCropModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [isProcessingCrop, setIsProcessingCrop] = useState(false);
  const [cropArea, setCropArea] = useState({ x: 50, y: 50, width: 200, height: 200 });
  const [isDragging, setIsDragging] = useState(false);
  const [isResizing, setIsResizing] = useState(false);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const [resizeHandle, setResizeHandle] = useState(null);
  const [initialCropArea, setInitialCropArea] = useState(null);
  const fileInputRef = useRef(null);
  const imageRef = useRef(null);

  // Componentes SVG personalizados para iconos que no existen en regular
  const ListCheckSVG = ({ style }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
      <path d="M13.3883 4.62317H3.09668M13.3883 10.1648H3.09668M9.43001 15.7065H3.09668M12.5967 14.9148L14.18 16.4982L17.3467 13.3315" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );

  const BuildingColumnsSVG = ({ style }) => (
    <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
      <path d="M8.63879 14.2444V8.70271M11.8055 14.2444V8.70271M14.9721 14.2444V8.70271M3.09713 17.411H17.3471M5.47213 14.2444V8.70271M9.52546 1.73446C9.74269 1.62893 9.98118 1.5745 10.2227 1.57533C10.4642 1.57615 10.7023 1.63221 10.9188 1.73921L17.146 4.78475C17.5229 4.96921 17.3915 5.53604 16.9719 5.53604H3.47238C3.05279 5.53604 2.92217 4.96921 3.29821 4.78475L9.52546 1.73446Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );

  const GearSVG = ({ style }) => (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
      <g clipPath="url(#clip0_151_381)">
        <path d="M9.6436 11.384C10.8755 11.384 11.8741 10.3854 11.8741 9.15349C11.8741 7.92161 10.8755 6.92297 9.6436 6.92297C8.41172 6.92297 7.41309 7.92161 7.41309 9.15349C7.41309 10.3854 8.41172 11.384 9.6436 11.384Z" stroke="currentColor" strokeWidth="0.915084" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15.1453 11.3841C15.0464 11.6083 15.0169 11.8571 15.0606 12.0983C15.1043 12.3394 15.2193 12.562 15.3907 12.7372L15.4353 12.7818C15.5736 12.9199 15.6833 13.0839 15.7581 13.2645C15.8329 13.445 15.8714 13.6385 15.8714 13.8339C15.8714 14.0293 15.8329 14.2228 15.7581 14.4033C15.6833 14.5839 15.5736 14.7479 15.4353 14.886C15.2972 15.0242 15.1332 15.1339 14.9527 15.2087C14.7722 15.2836 14.5787 15.3221 14.3833 15.3221C14.1878 15.3221 13.9943 15.2836 13.8138 15.2087C13.6333 15.1339 13.4693 15.0242 13.3312 14.886L13.2866 14.8414C13.1114 14.6699 12.8888 14.555 12.6476 14.5112C12.4064 14.4675 12.1577 14.497 11.9334 14.596C11.7135 14.6902 11.5259 14.8467 11.3938 15.0462C11.2617 15.2457 11.1909 15.4794 11.1899 15.7187V15.8451C11.1899 16.2395 11.0332 16.6177 10.7544 16.8966C10.4755 17.1754 10.0973 17.3321 9.70289 17.3321C9.30851 17.3321 8.93028 17.1754 8.65141 16.8966C8.37254 16.6177 8.21587 16.2395 8.21587 15.8451V15.7782C8.21012 15.5321 8.13046 15.2934 7.98725 15.0932C7.84405 14.893 7.64392 14.7404 7.41289 14.6555C7.18863 14.5565 6.93987 14.527 6.69869 14.5707C6.4575 14.6144 6.23494 14.7294 6.05971 14.9008L6.0151 14.9454C5.87699 15.0837 5.71299 15.1934 5.53247 15.2682C5.35195 15.343 5.15845 15.3816 4.96304 15.3816C4.76762 15.3816 4.57412 15.343 4.3936 15.2682C4.21308 15.1934 4.04908 15.0837 3.91098 14.9454C3.77272 14.8073 3.66304 14.6433 3.58821 14.4628C3.51337 14.2823 3.47486 14.0888 3.47486 13.8934C3.47486 13.698 3.51337 13.5045 3.58821 13.3239C3.66304 13.1434 3.77272 12.9794 3.91098 12.8413L3.95559 12.7967C4.12699 12.6215 4.24197 12.3989 4.28571 12.1577C4.32944 11.9165 4.29992 11.6678 4.20094 11.4435C4.1067 11.2236 3.9502 11.0361 3.75073 10.904C3.55125 10.7719 3.3175 10.701 3.07825 10.7H2.95185C2.55747 10.7 2.17925 10.5434 1.90038 10.2645C1.62151 9.98562 1.46484 9.6074 1.46484 9.21302C1.46484 8.81864 1.62151 8.44041 1.90038 8.16154C2.17925 7.88267 2.55747 7.72601 2.95185 7.72601H3.01877C3.26487 7.72025 3.50354 7.64059 3.70376 7.49739C3.90398 7.35418 4.05649 7.15405 4.14146 6.92302C4.24044 6.69877 4.26996 6.45001 4.22623 6.20882C4.18249 5.96763 4.06751 5.74507 3.89611 5.56984L3.8515 5.52523C3.71324 5.38713 3.60356 5.22313 3.52873 5.04261C3.45389 4.86209 3.41538 4.66859 3.41538 4.47317C3.41538 4.27775 3.45389 4.08425 3.52873 3.90373C3.60356 3.72321 3.71324 3.55921 3.8515 3.42111C3.9896 3.28285 4.1536 3.17317 4.33412 3.09834C4.51464 3.02351 4.70814 2.98499 4.90356 2.98499C5.09897 2.98499 5.29247 3.02351 5.47299 3.09834C5.65351 3.17317 5.81751 3.28285 5.95562 3.42111L6.00023 3.46572C6.17546 3.63712 6.39801 3.75211 6.6392 3.79584C6.88039 3.83957 7.12915 3.81005 7.35341 3.71108H7.41289C7.63279 3.61683 7.82034 3.46033 7.95244 3.26086C8.08455 3.06138 8.15544 2.82763 8.15639 2.58838V2.46199C8.15639 2.06761 8.31306 1.68938 8.59193 1.41051C8.8708 1.13164 9.24902 0.974976 9.6434 0.974976C10.0378 0.974976 10.416 1.13164 10.6949 1.41051C10.9737 1.68938 11.1304 2.06761 11.1304 2.46199V2.5289C11.1314 2.76815 11.2023 3.0019 11.3344 3.20138C11.4665 3.40085 11.654 3.55735 11.8739 3.6516C12.0982 3.75057 12.3469 3.78009 12.5881 3.73636C12.8293 3.69263 13.0519 3.57764 13.2271 3.40624L13.2717 3.36163C13.4098 3.22337 13.5738 3.11369 13.7543 3.03886C13.9349 2.96403 14.1284 2.92551 14.3238 2.92551C14.5192 2.92551 14.7127 2.96403 14.8932 3.03886C15.0737 3.11369 15.2377 3.22337 15.3758 3.36163C15.5141 3.49973 15.6238 3.66373 15.6986 3.84425C15.7734 4.02477 15.812 4.21827 15.812 4.41369C15.812 4.6091 15.7734 4.8026 15.6986 4.98313C15.6238 5.16365 15.5141 5.32765 15.3758 5.46575L15.3312 5.51036C15.1598 5.68559 15.0448 5.90815 15.0011 6.14934C14.9574 6.39053 14.9869 6.63929 15.0859 6.86354V6.92302C15.1801 7.14293 15.3366 7.33047 15.5361 7.46258C15.7356 7.59468 15.9693 7.66557 16.2086 7.66653H16.335C16.7293 7.66653 17.1076 7.82319 17.3864 8.10206C17.6653 8.38093 17.822 8.75916 17.822 9.15354C17.822 9.54792 17.6653 9.92614 17.3864 10.205C17.1076 10.4839 16.7293 10.6405 16.335 10.6405H16.268C16.0288 10.6415 15.795 10.7124 15.5956 10.8445C15.3961 10.9766 15.2396 11.1641 15.1453 11.3841Z" stroke="currentColor" strokeWidth="0.915084" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_151_381">
          <rect width="17.8441" height="17.8441" fill="white" transform="translate(0.72168 0.231445)" />
        </clipPath>
      </defs>
    </svg>
  );

  const UserSVG = ({ style }) => (
    <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
      <path d="M14.4478 14.8316V13.4209C14.4478 12.6726 14.1586 11.9549 13.6437 11.4258C13.1289 10.8966 12.4306 10.5994 11.7026 10.5994H6.21205C5.48396 10.5994 4.7857 10.8966 4.27086 11.4258C3.75603 11.9549 3.4668 12.6726 3.4668 13.4209V14.8316" stroke="currentColor" strokeWidth="0.915084" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.95717 7.77778C10.4733 7.77778 11.7024 6.51455 11.7024 4.95627C11.7024 3.398 10.4733 2.13477 8.95717 2.13477C7.441 2.13477 6.21191 3.398 6.21191 4.95627C6.21191 6.51455 7.441 7.77778 8.95717 7.77778Z" stroke="currentColor" strokeWidth="0.915084" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );

  // eslint-disable-next-line no-unused-vars -- usado en JSX (CommentSVG)
  const CommentSVG = ({ style }) => (
    <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
      <path d="M11.2217 9.99064H11.2304M14.7217 9.99064H14.7304M7.72168 9.99064H7.73043M19.9717 14.9906C19.9717 15.4327 19.7873 15.8566 19.4591 16.1692C19.1309 16.4817 18.6858 16.6573 18.2217 16.6573H6.69618C6.23209 16.6574 5.78704 16.8331 5.45893 17.1456L3.53218 18.9806C3.4453 19.0634 3.33461 19.1197 3.21411 19.1425C3.09361 19.1654 2.96871 19.1536 2.8552 19.1089C2.74169 19.0641 2.64467 18.9883 2.5764 18.891C2.50814 18.7937 2.4717 18.6793 2.47168 18.5623V4.99064C2.47168 4.54861 2.65605 4.12469 2.98424 3.81213C3.31243 3.49957 3.75755 3.32397 4.22168 3.32397H18.2217C18.6858 3.32397 19.1309 3.49957 19.4591 3.81213C19.7873 4.12469 19.9717 4.54861 19.9717 4.99064V14.9906Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1200);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  const bancosDisponibles = useMemo(() => [
    { nombre: "BROU", requiereSucursal: false },
    { nombre: "Banco Hipotecario del Uruguay", requiereSucursal: false },
    { nombre: "Bandes", requiereSucursal: false },
    { nombre: "Itau", requiereSucursal: false },
    { nombre: "Scotiabank", requiereSucursal: false },
    { nombre: "Santander", requiereSucursal: false },
    { nombre: "BBVA", requiereSucursal: false },
    { nombre: "HSBC", requiereSucursal: false },
    { nombre: "Heritage", requiereSucursal: false },
    { nombre: "Citibank", requiereSucursal: false },
    { nombre: "Banco de la Nación Argentina", requiereSucursal: false },
    { nombre: "PREX", requiereSucursal: false },
    { nombre: "MIDINERO", requiereSucursal: false },
    { nombre: "Mi Dinero", requiereSucursal: false },
    { nombre: "OCA Blue", requiereSucursal: false },
    { nombre: "BAPRO", requiereSucursal: false },
  ], []);

  // eslint-disable-next-line no-unused-vars -- reservado para uso futuro
  const _handleLogout = () => {
    // Eliminar JWT de las cookies
    document.cookie = "jwt=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    // Eliminar JWT del local storage
    localStorage.removeItem('jwt');
    // Recargar la página
    window.location.reload();
  };

  const handleNotificationsClick = (event) => {
    setNotificationsAnchorEl(event.currentTarget);
  };

  const handleNotificationsClose = () => {
    setNotificationsAnchorEl(null);
  };

  const baseURL = process.env.REACT_APP_BASE_URL;





  useEffect(() => {
    // Kickout solo si Firebase confirma que no hay usuario autenticado
    if (!authLoading && !user) {
      navigate("/authentication/sign-in");
      return;
    }
  }, [navigate, user, authLoading]);

  // Cargar datos desde el contexto cuando estén disponibles
  useEffect(() => {
    if (isDataLoaded) {
      if (descripcionContext) setDescripcion(descripcionContext);
      if (bancoContext) setBanco(bancoContext);
      if (profesionContext) setProfesion(profesionContext);
      if (numeroCuentaContext) setNumeroCuenta(numeroCuentaContext);
      if (numeroSucursalContext) setNumeroSucursal(numeroSucursalContext);
      if (labelsContext && Array.isArray(labelsContext)) setEspecialidades(labelsContext);

      // Actualizar datos del profesional para la vista previa
      setProfesionalData({
        nombre: nombreContext || "",
        apellido: apellidoContext || "",
        email: emailContext || "",
        celular: celularContext || "",
        imagen: imagenContext || "",
        genero: generoContext || "",
        honorarios: honorariosContext || 0
      });
    }
  }, [isDataLoaded, descripcionContext, bancoContext, profesionContext, numeroCuentaContext, numeroSucursalContext, labelsContext, nombreContext, apellidoContext, emailContext, celularContext, imagenContext, generoContext, honorariosContext]);

  useEffect(() => {
    const bancoSeleccionado = bancosDisponibles.find((b) => b.nombre === banco);
    setMostrarSucursal(bancoSeleccionado?.requiereSucursal || false);
  }, [banco, bancosDisponibles]);

  // Hook para validar cuenta bancaria cuando cambian banco o número de cuenta
  useEffect(() => {


    // Solo validar si ambos están completos y el banco está en el mapeo
    if (banco && numeroCuenta && bankNameToCode[banco]) {
      const bank_code = bankNameToCode[banco];
      const account_number = numeroCuenta;
      const country_code = "UY";



      setCuentaBancariaValida(null);
      setMensajeCuentaBancaria("Validando cuenta...");

      const validateAccount = async () => {
        const token = await getToken();
        if (!token) {
          navigate("/authentication/sign-in");
          return;
        }

        fetch("https://sandbox.payflexapp.com/validar-cuenta", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
          body: JSON.stringify({ bank_code, account_number, country_code })
        })
          .then(res => {

            if (!res.ok) {
              throw new Error(`HTTP error! status: ${res.status}`);
            }
            return res.json();
          })
          .then(data => {

            // Intentar diferentes estructuras de respuesta
            let isValid = false;
            let message = "Cuenta bancaria no válida";

            if (data && data.data) {
              // Estructura: { data: { valid: true/false, message: "..." } }
              isValid = data.data.valid === true || data.data.valid === "true";
              message = data.data.message || message;
            } else if (data && typeof data.valid !== 'undefined') {
              // Estructura: { valid: true/false, message: "..." }
              isValid = data.valid === true || data.valid === "true";
              message = data.message || message;
            } else if (data && data.success !== undefined) {
              // Estructura: { success: true/false, message: "..." }
              isValid = data.success === true || data.success === "true";
              message = data.message || message;
            }


            if (isValid) {

              setCuentaBancariaValida(true);
              setMensajeCuentaBancaria("Cuenta bancaria válida");
            } else {

              setCuentaBancariaValida(false);
              setMensajeCuentaBancaria(message);
            }
          })
          .catch((error) => {

            setCuentaBancariaValida(false);
            setMensajeCuentaBancaria(`Error de validación`);
          });
      };

      validateAccount();
    } else {

      setCuentaBancariaValida(null);
      setMensajeCuentaBancaria("");
    }
  }, [banco, numeroCuenta, getToken, navigate]);

  // Función para validar el formato del número de cuenta
  const validarFormatoCuenta = () => {
    if (!banco || !numeroCuenta) return true; // No validar si no hay banco o cuenta

    const restricciones = restriccionesPorBanco(banco);
    return restricciones.pattern.test(numeroCuenta);
  };

  // Funciones para cambio de foto de perfil
  const handleImageClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validar tipo de archivo
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
    if (!allowedTypes.includes(file.type)) {
      alert('Por favor, selecciona una imagen válida (JPEG, PNG o GIF)');
      return;
    }

    // Validar tamaño (máximo 5MB)
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (file.size > maxSize) {
      alert('La imagen debe ser menor a 5MB');
      return;
    }

    // Crear URL para la imagen
    const imageUrl = URL.createObjectURL(file);
    setSelectedImage({ file, url: imageUrl });
    setShowCropModal(true);
    setIsProcessingCrop(false);

    // Limpiar el input
    event.target.value = '';
  };

  const handleImageLoad = () => {
    console.log('Image loaded');
    setImageLoaded(true);
  };

  const handleCropCancel = () => {
    setShowCropModal(false);
    setImageLoaded(false);
    setIsProcessingCrop(false);
    if (selectedImage) {
      URL.revokeObjectURL(selectedImage.url);
      setSelectedImage(null);
    }
  };

  // 1. Handler para iniciar movimiento del área de recorte
  const handleCropAreaMouseDown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!imageRef.current || !imageLoaded) return;

    const rect = imageRef.current.getBoundingClientRect();
    let clientX, clientY;

    // Manejar tanto eventos de mouse como táctiles
    if (e.touches && e.touches[0]) {
      clientX = e.touches[0].clientX;
      clientY = e.touches[0].clientY;
    } else {
      clientX = e.clientX;
      clientY = e.clientY;
    }

    const mouseX = clientX - rect.left;
    const mouseY = clientY - rect.top;

    setIsDragging(true);
    setDragOffset({
      x: mouseX - cropArea.x,
      y: mouseY - cropArea.y
    });
  };

  // 2. Handler para iniciar redimensionamiento desde un handle
  const handleResizeHandleMouseDown = (handle) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!imageRef.current || !imageLoaded) return;

    const rect = imageRef.current.getBoundingClientRect();
    let clientX, clientY;

    // Manejar tanto eventos de mouse como táctiles
    if (e.touches && e.touches[0]) {
      clientX = e.touches[0].clientX;
      clientY = e.touches[0].clientY;
    } else {
      clientX = e.clientX;
      clientY = e.clientY;
    }

    const mouseX = clientX - rect.left;
    const mouseY = clientY - rect.top;

    setIsResizing(true);
    setResizeHandle(handle);
    setInitialCropArea({ ...cropArea });
    setDragOffset({
      x: mouseX - cropArea.x,
      y: mouseY - cropArea.y
    });
  };

  useEffect(() => {
    if (showCropModal && imageLoaded) {
      const handleGlobalMouseMove = (e) => {
        if (!imageRef.current) return;

        const rect = imageRef.current.getBoundingClientRect();
        let clientX, clientY;

        // Manejar tanto eventos de mouse como táctiles
        if (e.touches && e.touches[0]) {
          clientX = e.touches[0].clientX;
          clientY = e.touches[0].clientY;
        } else {
          clientX = e.clientX;
          clientY = e.clientY;
        }

        const mouseX = clientX - rect.left;
        const mouseY = clientY - rect.top;

        if (isDragging) {
          const newX = mouseX - dragOffset.x;
          const newY = mouseY - dragOffset.y;

          const maxX = rect.width - cropArea.width;
          const maxY = rect.height - cropArea.height;

          setCropArea(prev => ({
            ...prev,
            x: Math.max(0, Math.min(newX, maxX)),
            y: Math.max(0, Math.min(newY, maxY))
          }));
        } else if (isResizing && initialCropArea) {
          const deltaX = mouseX - (initialCropArea.x + dragOffset.x);
          const deltaY = mouseY - (initialCropArea.y + dragOffset.y);

          let newCropArea = { ...initialCropArea };

          switch (resizeHandle) {
            case 'top-left':
              newCropArea.x = Math.max(0, Math.min(initialCropArea.x + deltaX, initialCropArea.x + initialCropArea.width - 50));
              newCropArea.y = Math.max(0, Math.min(initialCropArea.y + deltaY, initialCropArea.y + initialCropArea.height - 50));
              newCropArea.width = initialCropArea.x + initialCropArea.width - newCropArea.x;
              newCropArea.height = initialCropArea.y + initialCropArea.height - newCropArea.y;
              break;
            case 'top-right':
              newCropArea.y = Math.max(0, Math.min(initialCropArea.y + deltaY, initialCropArea.y + initialCropArea.height - 50));
              newCropArea.width = Math.max(50, Math.min(initialCropArea.width + deltaX, rect.width - initialCropArea.x));
              newCropArea.height = initialCropArea.y + initialCropArea.height - newCropArea.y;
              break;
            case 'bottom-left':
              newCropArea.x = Math.max(0, Math.min(initialCropArea.x + deltaX, initialCropArea.x + initialCropArea.width - 50));
              newCropArea.width = initialCropArea.x + initialCropArea.width - newCropArea.x;
              newCropArea.height = Math.max(50, Math.min(initialCropArea.height + deltaY, rect.height - initialCropArea.y));
              break;
            case 'bottom-right':
              newCropArea.width = Math.max(50, Math.min(initialCropArea.width + deltaX, rect.width - initialCropArea.x));
              newCropArea.height = Math.max(50, Math.min(initialCropArea.height + deltaY, rect.height - initialCropArea.y));
              break;
            case 'top':
              newCropArea.y = Math.max(0, Math.min(initialCropArea.y + deltaY, initialCropArea.y + initialCropArea.height - 50));
              newCropArea.height = initialCropArea.y + initialCropArea.height - newCropArea.y;
              break;
            case 'bottom':
              newCropArea.height = Math.max(50, Math.min(initialCropArea.height + deltaY, rect.height - initialCropArea.y));
              break;
            case 'left':
              newCropArea.x = Math.max(0, Math.min(initialCropArea.x + deltaX, initialCropArea.x + initialCropArea.width - 50));
              newCropArea.width = initialCropArea.x + initialCropArea.width - newCropArea.x;
              break;
            case 'right':
              newCropArea.width = Math.max(50, Math.min(initialCropArea.width + deltaX, rect.width - initialCropArea.x));
              break;
            default:
              break;
          }

          setCropArea(newCropArea);
        }
      };

      const handleGlobalMouseUp = () => {
        setIsDragging(false);
        setIsResizing(false);
        setResizeHandle(null);
        setInitialCropArea(null);
      };

      // Prevenir el scroll en dispositivos móviles durante el recorte
      const preventScroll = (e) => {
        if (isDragging || isResizing) {
          e.preventDefault();
        }
      };

      document.addEventListener('mousemove', handleGlobalMouseMove);
      document.addEventListener('mouseup', handleGlobalMouseUp);
      document.addEventListener('touchmove', handleGlobalMouseMove, { passive: false });
      document.addEventListener('touchend', handleGlobalMouseUp);
      document.addEventListener('touchmove', preventScroll, { passive: false });

      return () => {
        document.removeEventListener('mousemove', handleGlobalMouseMove);
        document.removeEventListener('mouseup', handleGlobalMouseUp);
        document.removeEventListener('touchmove', handleGlobalMouseMove);
        document.removeEventListener('touchend', handleGlobalMouseUp);
        document.removeEventListener('touchmove', preventScroll);
      };
    }
  }, [showCropModal, imageLoaded, isDragging, isResizing, cropArea, dragOffset, initialCropArea, resizeHandle]);

  // Prevenir scroll del body cuando el modal está abierto
  useEffect(() => {
    if (showCropModal) {
      const originalStyle = window.getComputedStyle(document.body).overflow;
      document.body.style.overflow = 'hidden';
      document.body.style.touchAction = 'none';

      return () => {
        document.body.style.overflow = originalStyle;
        document.body.style.touchAction = '';
      };
    }
  }, [showCropModal]);

  const handleCropAccept = async () => {
    if (!selectedImage) return;

    // Verificar que la imagen siga montada y cargada
    if (!imageRef.current || !imageLoaded) {
      alert('La imagen no está lista para recortar. Por favor, vuelve a intentarlo.');
      return;
    }

    setIsProcessingCrop(true);
    setIsUploadingImage(true);

    try {
      // Crear un canvas para recortar la imagen
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();

      img.onload = async () => {
        // Obtener las dimensiones reales de la imagen y del contenedor
        const imgRect = imageRef.current ? imageRef.current.getBoundingClientRect() : null;
        if (!imgRect) {
          alert('No se pudo obtener la referencia de la imagen.');
          setIsUploadingImage(false);
          setIsProcessingCrop(false);
          return;
        }
        const imgNaturalWidth = img.naturalWidth;
        const imgNaturalHeight = img.naturalHeight;
        const imgDisplayWidth = imgRect.width;
        const imgDisplayHeight = imgRect.height;

        // Calcular las escalas
        const scaleX = imgNaturalWidth / imgDisplayWidth;
        const scaleY = imgNaturalHeight / imgDisplayHeight;

        // Calcular las coordenadas reales en la imagen original
        const realCropX = cropArea.x * scaleX;
        const realCropY = cropArea.y * scaleY;
        const realCropWidth = cropArea.width * scaleX;
        const realCropHeight = cropArea.height * scaleY;

        // Configurar el canvas con el tamaño del recorte
        canvas.width = realCropWidth;
        canvas.height = realCropHeight;

        // Dibujar la parte recortada usando las coordenadas reales
        ctx.drawImage(
          img,
          realCropX, realCropY, realCropWidth, realCropHeight,
          0, 0, realCropWidth, realCropHeight
        );

        // Convertir el canvas a blob
        canvas.toBlob(async (blob) => {
          try {
            const formData = new FormData();
            formData.append('file', blob, 'cropped-image.jpg');

            const token = await getToken();
            if (!token) {
              setIsUploadingImage(false);
              setShowCropModal(false);
              setMensaje("Error: No se pudo obtener el token de autenticación");
              return;
            }

            const response = await fetch(`${baseURL}/upload-profesional-image`, {
              method: 'POST',
              headers: {
                'Authorization': `Bearer ${token}`,
              },
              body: formData,
            });

            if (!response.ok) {
              const errorData = await response.json().catch(() => ({}));
              throw new Error(errorData.error || `Error HTTP: ${response.status}`);
            }

            const data = await response.json();

            // Actualizar el estado local con la nueva imagen
            setProfesionalData(prevData => ({
              ...prevData,
              imagen: data.url_original
            }));

            // Recargar la página para mostrar los cambios
            window.location.reload();
          } catch (error) {
            console.error('Error al subir la imagen:', error);
            alert(`Error al subir la imagen: ${error.message}`);
            setIsUploadingImage(false);
            setIsProcessingCrop(false);
          } finally {
            setShowCropModal(false);
          }
        }, 'image/jpeg', 0.9);
      };

      img.src = selectedImage.url;

    } catch (error) {
      console.error('Error al procesar la imagen:', error);
      alert('Error al procesar la imagen. Por favor, intenta de nuevo.');
      setIsUploadingImage(false);
      setIsProcessingCrop(false);
      setShowCropModal(false);
    }
  };

  // Componente de vista previa del perfil
  // eslint-disable-next-line no-unused-vars -- reservado para uso futuro
  const _ProfilePreview = () => {
    const getEspecialidadLabel = (value) => {
      const especialidad = especialidadesData.find(esp => esp.value === value);
      return especialidad ? especialidad.label : value;
    };

    return (
      <Card sx={{
        width: '100%',
        maxWidth: 500,
        borderRadius: '20px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
        p: 3,
        background: '#f9f9f9',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* SVG decorativo */}
        <svg
          style={{
            position: 'absolute',
            left: 0,
            top: 0,
            width: '80px',
            height: '40px',
            zIndex: 1
          }}
          viewBox="0 0 80 40"
          xmlns="http://www.w3.org/2000/svg"
        >
          <ellipse cx="0" cy="0" rx="80" ry="40" fill="#e2f2f1" />
        </svg>

        <Typography variant="h6" sx={{ mb: 3, textAlign: 'center', color: '#938f7f' }}>
          Vista Previa de tu Perfil
        </Typography>

        {/* Foto del profesional */}
        <ArgonBox display="flex" justifyContent="center" mb={2}>
          <div style={{ position: 'relative' }}>
            <img
              src={profesionalData.imagen || (profesionalData && profesionalData.genero === 'F'
                ? 'https://i.ibb.co/FBnpswy/young-smiling-woman-mia-avatar-260nw-2127358541.jpg'
                : 'https://iili.io/3xJfssa.th.png')}
              alt={`${profesionalData.nombre} ${profesionalData.apellido}`}
              onClick={handleImageClick}
              style={{
                width: '120px',
                height: '120px',
                borderRadius: '50%',
                objectFit: 'cover',
                boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
                border: profesionalData.imagen ? '5px solid white' : '4px solid white',
                zIndex: 2,
                position: 'relative',
                cursor: 'pointer',
                opacity: isUploadingImage ? 0.6 : 1,
                transition: 'opacity 0.3s ease'
              }}
            />
            <button
              type="button"
              onClick={handleImageClick}
              style={{
                position: 'absolute',
                bottom: '1px',
                right: '10px',
                background: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '30px',
                height: '30px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                cursor: 'pointer',
                zIndex: 10
              }}
              aria-label="Cambiar foto de perfil"
            >
              <EditIcon style={{ color: '#0096dc', fontSize: '13px' }} />
            </button>
            {isUploadingImage && (
              <div style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                color: '#0096dc',
                fontWeight: 'bold',
                fontSize: '14px'
              }}>
                Subiendo...
              </div>
            )}
          </div>
        </ArgonBox>

        {/* Tipo de consulta */}
        <ArgonBox textAlign="center" mb={2}>
          <Typography variant="caption" sx={{ color: '#888', mb: 1, display: 'block' }}>
            Tipo de consulta:
          </Typography>
          <ArgonBox display="flex" justifyContent="center" gap={1}>
            <ArgonBox
              sx={{
                background: '#EBFFF0',
                color: '#00AD62',
                px: 3,
                py: 0.8,
                borderRadius: '20px',
                fontSize: '12px',
                fontWeight: 'bold',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                minWidth: '70px',
                textAlign: 'center'
              }}
            >
              {profesion === 'Directorio Médico' ? 'PRESENCIAL' : 'ONLINE'}
            </ArgonBox>
            <ArgonBox
              sx={{
                background: '#1F85F6',
                color: 'white',
                px: 3,
                py: 0.8,
                borderRadius: '20px',
                fontSize: '12px',
                fontWeight: 'bold',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                minWidth: '70px',
                textAlign: 'center'
              }}
            >
              URUGUAY
            </ArgonBox>
          </ArgonBox>
        </ArgonBox>

        {/* Información del profesional */}
        <ArgonBox sx={{ textAlign: 'left', width: '100%', mt: 2 }}>
          <hr style={{
            border: 'none',
            height: '1px',
            background: 'linear-gradient(90deg, transparent, #ccc, transparent)',
            margin: '20px 0',
            width: '100%'
          }} />

          <Typography variant="h5" sx={{ color: '#938f7f', mb: 2, fontWeight: 'bold' }}>
            {profesionalData.nombre} {profesionalData.apellido}
          </Typography>

          <Typography variant="body1" sx={{ color: '#868686', lineHeight: 1.6, mb: 2 }}>
            {descripcion || "Sin descripción"}
          </Typography>

          <ArgonBox
            sx={{
              background: '#fdbdb4',
              color: 'white',
              px: 2,
              py: 1,
              borderRadius: '20px',
              fontSize: '12px',
              fontWeight: 'bold',
              display: 'inline-block',
              mb: 2,
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
            }}
          >
            {profesion === 'Psicólogo Online' ? 'Lic.Psicología' :
              profesion === 'Directorio Médico' ? 'Dr.Medicina' :
                profesion === 'Nutricionista' ? 'Lic.Nutrición' : 'Lic.Psicología'}
          </ArgonBox>

          {/* Labels del profesional */}
          {especialidades.length > 0 && (
            <ArgonBox display="flex" flexWrap="wrap" gap={1} mb={2}>
              {especialidades.map((label, idx) => (
                <ArgonBox
                  key={idx}
                  sx={{
                    background: '#e9ecef',
                    color: '#495057',
                    px: 1.5,
                    py: 0.5,
                    borderRadius: '15px',
                    fontSize: '12px',
                    fontWeight: 500,
                    textTransform: 'capitalize'
                  }}
                >
                  {getEspecialidadLabel(label)}
                </ArgonBox>
              ))}
            </ArgonBox>
          )}

          {/* Precio o información de contacto */}
          {profesion === 'Directorio Médico' ? (
            <ArgonBox textAlign="center" mt={2}>
              <ArgonBox
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                  background: '#f8f9fa',
                  borderRadius: '12px',
                  p: 2,
                  mb: 2,
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                  border: '1px solid #e9ecef'
                }}
              >
                <ArgonBox
                  sx={{
                    background: '#7eccbc',
                    color: 'white',
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mr: 1.5,
                    boxShadow: '0 2px 8px rgba(126, 204, 188, 0.3)'
                  }}
                >

                </ArgonBox>
                <ArgonBox display="flex" flexDirection="column" alignItems="flex-start">
                  <Typography variant="caption" sx={{ color: '#6c757d', fontWeight: 500, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                    WhatsApp
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 600, color: '#333' }}>
                    {profesionalData.celular || '098 589 701'}
                  </Typography>
                </ArgonBox>
              </ArgonBox>

              <ArgonBox
                sx={{
                  background: '#7eccbc',
                  color: 'white',
                  border: 'none',
                  borderRadius: '25px',
                  px: 4,
                  py: 1.5,
                  fontSize: '16px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  boxShadow: '0 4px 15px rgba(126, 204, 188, 0.3)',
                  width: '100%',
                  maxWidth: '300px'
                }}
              >
                Contactar
              </ArgonBox>
            </ArgonBox>
          ) : (
            <ArgonBox textAlign="center" mt={2}>
              {/* Card de precio minimalista */}
              <ArgonBox
                sx={{
                  background: 'white',
                  borderRadius: '8px',
                  p: 2.5,
                  mb: 2,
                  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                  border: '1px solid #e1e5e9',
                  position: 'relative',
                  overflow: 'hidden'
                }}
              >
                <ArgonBox
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '4px',
                    height: '100%',
                    background: '#7eccbc'
                  }}
                />
                <ArgonBox display="flex" alignItems="center" justifyContent="space-between" gap={1.5}>
                  <ArgonBox flex={1}>
                    <Typography variant="h6" sx={{ fontWeight: 700, color: '#7eccbc', mb: 0.5 }}>
                      ${profesionalData.honorarios || 0}
                    </Typography>
                    <Typography variant="caption" sx={{ color: '#7f8c8d', fontWeight: 500, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                      por consulta
                    </Typography>
                  </ArgonBox>
                </ArgonBox>
              </ArgonBox>


            </ArgonBox>
          )}
        </ArgonBox>
      </Card>
    );
  };

  // eslint-disable-next-line no-unused-vars -- reservado para uso futuro
  const _handleSubmit = async () => {
    // Validar longitud de descripción
    if (descripcion.length > 250) {
      setMensaje("La descripción no puede exceder los 250 caracteres.");
      return;
    }

    // Validar número de especialidades
    if (profesion === "Psicólogo Online" && especialidades.length > 10) {
      setMensaje("No puedes seleccionar más de 10 especialidades.");
      return;
    }

    // Validar formato del número de cuenta
    if (!validarFormatoCuenta()) {
      setMensaje("El formato del número de cuenta no es válido para el banco seleccionado.");
      return;
    }

    // Validar que la cuenta bancaria sea válida si se ha validado
    if (cuentaBancariaValida === false) {
      setMensaje("La cuenta bancaria no es válida. Por favor, verifica los datos.");
      return;
    }

    try {
      const payload = {
        descripcion,
        banco,
        numeroCuenta,
      };

      if (mostrarSucursal) {
        payload.numeroSucursal = numeroSucursal;
      }

      if (profesion === "Psicólogo Online" && especialidades.length > 0) {
        payload.labels = especialidades;
      }

      const token = await getToken();
      if (!token) {
        setMensaje("Error: No se pudo obtener el token de autenticación");
        navigate("/authentication/sign-in");
        return;
      }

      await fetch(`${baseURL}/actualizar-profesional/${profesionalId}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
      setMensaje("Datos actualizados con éxito");
    } catch (error) {
      setMensaje("Hubo un error al actualizar los datos. Por favor, inténtalo nuevamente.");
    }
  };


  if (userLoading && !isDataLoaded) {
    return <PerfilSkeleton />;
  }

  return (
    <>
      <div style={{
        minHeight: '100vh',
        backgroundColor: 'white',
        padding: '20px',
        paddingBottom: '100px', // Espacio para el BottomTabBar (80px + 20px extra)
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          maxWidth: '400px',
          marginBottom: '20px',
          position: 'relative'
        }}>
          <h1 style={{
            fontWeight: 'bold',
            color: '#000',
            fontSize: '20px',
            margin: 0,
            fontFamily: 'system-ui, -apple-system, sans-serif'
          }}>
            Perfil
          </h1>
          <IconButton
            onClick={handleNotificationsClick}
            sx={{
              color: "#666",
              padding: '4px',
              position: 'absolute',
              right: 0
            }}
          >
            <NotificationsOutlined />
          </IconButton>
        </div>

        {/* Foto de perfil */}
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '2px' }}>
          <div style={{ position: 'relative' }}>
            <img
              src={profesionalData.imagen || (profesionalData && profesionalData.genero === 'F'
                ? 'https://i.ibb.co/FBnpswy/young-smiling-woman-mia-avatar-260nw-2127358541.jpg'
                : 'https://iili.io/3xJfssa.th.png')}
              alt={`${profesionalData.nombre} ${profesionalData.apellido}`}
              onClick={handleImageClick}
              style={{
                width: '120px',
                height: '120px',
                borderRadius: '50%',
                objectFit: 'cover',
                boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
                border: '4px solid white',
                cursor: 'pointer',
                opacity: isUploadingImage ? 0.6 : 1,
                transition: 'opacity 0.3s ease'
              }}
            />
            <button
              type="button"
              onClick={handleImageClick}
              style={{
                position: 'absolute',
                bottom: '5px',
                right: '5px',
                background: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '30px',
                height: '30px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                cursor: 'pointer'
              }}
              aria-label="Cambiar foto de perfil"
            >
              <EditIcon style={{ color: '#0096dc', fontSize: '13px' }} />
            </button>
            {isUploadingImage && (
              <div style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                color: '#0096dc',
                fontWeight: 'bold',
                fontSize: '14px'
              }}>
                Subiendo...
              </div>
            )}
          </div>
        </div>

        {/* Saludo */}
        <div style={{ textAlign: 'center', marginBottom: '24px', marginTop: '2px' }}>
          <h2 style={{
            fontWeight: 'bold',
            color: '#000',
            fontSize: '24px',
            marginBottom: '10px',
            margin: '0 0 10px 0',
            fontFamily: 'system-ui, -apple-system, sans-serif'
          }}>
            Hola, {profesionalData.nombre || 'Ignacio'} 👋
          </h2>

          {/* Botones de estado */}
          <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', marginBottom: '12px' }}>
            <div style={{
              background: '#EBFFF0',
              color: '#00AD62',
              padding: '6px 24px',
              borderRadius: '20px',
              fontSize: '14px',
              fontWeight: 'bold',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              minWidth: '80px',
              textAlign: 'center'
            }}>
              Online
            </div>
            <div style={{
              background: '#1F85F6',
              color: 'white',
              padding: '6px 24px',
              borderRadius: '20px',
              fontSize: '14px',
              fontWeight: 'bold',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              minWidth: '80px',
              textAlign: 'center'
            }}>
              Uruguay
            </div>
          </div>
        </div>

        {/* Card solo para el menú */}
        <div style={{
          width: '100%',
          maxWidth: '400px',
          borderRadius: '20px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          backgroundColor: 'white',
          overflow: 'hidden',
          marginTop: '8px'
        }}>
          {/* Lista de menú */}
          <div style={{ padding: '10px 20px' }}>
            {/* Mi descripción */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '15px 0',
                borderBottom: '1px solid #f0f0f0',
                cursor: 'pointer'
              }}
              onClick={() => {
                navigate('/mi-descripcion');
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <div style={{
                  width: '24px',
                  height: '24px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <ListCheckSVG style={{ fontSize: '20px', color: '#000000' }} />
                </div>
                <span style={{ color: '#000', fontSize: '16px', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
                  Mi descripción
                </span>
              </div>
              <div>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 18l6-6-6-6"></path>
                </svg>
              </div>
            </div>

            {/* Cuenta bancaria */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '15px 0',
                borderBottom: '1px solid #f0f0f0',
                cursor: 'pointer'
              }}
              onClick={() => {
                navigate('/cuenta-bancaria');
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <div style={{
                  width: '24px',
                  height: '24px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <BuildingColumnsSVG style={{ fontSize: '20px', color: '#000000' }} />
                </div>
                <span style={{ color: '#000', fontSize: '16px', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
                  Cuenta bancaria
                </span>
              </div>
              <div>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 18l6-6-6-6"></path>
                </svg>
              </div>
            </div>

            {/* Mensajes 
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '15px 0',
                borderBottom: '1px solid #f0f0f0',
                cursor: 'pointer'
                        }}
                        onClick={() => {
                // Aquí puedes agregar la lógica para mensajes
                console.log('Ver mensajes');
              }}
            >

              <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <div style={{
                  width: '24px',
                  height: '24px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <CommentSVG style={{ fontSize: '20px', color: '#000000' }} />
                </div>

                <span style={{ color: '#000', fontSize: '16px', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
                  Mensajes
                </span>
              </div>
              <div>
                
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 18l6-6-6-6"></path>
                </svg>
              </div>
            </div>
*/}
            {/* Ajustes */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '15px 0',
                borderBottom: '1px solid #f0f0f0',
                cursor: 'pointer'
              }}
              onClick={() => {
                navigate('/ajustes');
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <div style={{
                  width: '24px',
                  height: '24px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <GearSVG style={{ fontSize: '20px', color: '#000000' }} />
                </div>
                <span style={{ color: '#000', fontSize: '16px', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
                  Ajustes
                </span>
              </div>
              <div>

                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 18l6-6-6-6"></path>
                </svg>
              </div>
            </div>


            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '15px 0',
                cursor: 'pointer'
              }}
              onClick={() => {
                navigate('/soporte');
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <div style={{
                  width: '24px',
                  height: '24px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <UserSVG
                    style={{ fontSize: '20px', color: '#000000' }}
                    alt="Perfil"
                  />
                </div>
                <span style={{ color: '#000', fontSize: '16px', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
                  Ayuda
                </span>
              </div>
              <div>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 18l6-6-6-6"></path>
                </svg>
              </div>
            </div>

          </div>
        </div>


      </div>

      {/* Input file oculto para seleccionar imagen */}
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={handleFileSelect}
        style={{ display: 'none' }}
      />

      {/* Modal de recorte de imagen */}
      {showCropModal && selectedImage && (
        <div
          onClick={handleCropCancel}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            touchAction: 'none'
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              maxWidth: '500px',
              width: '90%',
              maxHeight: '90vh',
              overflow: 'hidden',
              touchAction: 'none',
              background: 'white',
              borderRadius: '12px',
              padding: '20px'
            }}
          >
            <Typography variant="h6" sx={{ mb: 2, textAlign: 'center' }}>
              Recortar imagen
            </Typography>
            <div style={{
              position: 'relative',
              display: 'inline-block',
              margin: '20px 0',
              border: '2px solid #ddd',
              borderRadius: '8px',
              overflow: 'hidden',
              touchAction: 'none'
            }}>
              <img
                ref={imageRef}
                src={selectedImage.url}
                alt="Preview"
                onLoad={handleImageLoad}
                style={{
                  maxWidth: '100%',
                  maxHeight: '400px',
                  display: 'block',
                  userSelect: 'none',
                  WebkitUserSelect: 'none',
                  MozUserSelect: 'none',
                  msUserSelect: 'none',
                  pointerEvents: 'auto',
                  touchAction: 'none'
                }}
                draggable={false}
              />
              {/* Área de recorte */}
              <div
                style={{
                  position: 'absolute',
                  left: cropArea.x,
                  top: cropArea.y,
                  width: cropArea.width,
                  height: cropArea.height,
                  border: '2px solid #0096dc',
                  backgroundColor: 'rgba(0, 150, 220, 0.1)',
                  cursor: isDragging ? 'grabbing' : 'move',
                  boxSizing: 'border-box',
                  zIndex: 2,
                  touchAction: 'none'
                }}
                onMouseDown={handleCropAreaMouseDown}
                onTouchStart={handleCropAreaMouseDown}
              >
                {/* Handles de redimensionamiento */}
                {['top-left', 'top-right', 'bottom-left', 'bottom-right', 'top', 'bottom', 'left', 'right'].map(handle => (
                  <div
                    key={handle}
                    style={{
                      position: 'absolute',
                      width: '20px',
                      height: '20px',
                      backgroundColor: '#0096dc',
                      border: '1px solid white',
                      cursor: handle.includes('top') && handle.includes('left') ? 'nw-resize' :
                        handle.includes('top') && handle.includes('right') ? 'ne-resize' :
                          handle.includes('bottom') && handle.includes('left') ? 'sw-resize' :
                            handle.includes('bottom') && handle.includes('right') ? 'se-resize' :
                              handle === 'top' || handle === 'bottom' ? 'ns-resize' : 'ew-resize',
                      left: handle.includes('left') ? '-10px' : handle.includes('right') ? 'calc(100% - 10px)' : 'calc(50% - 10px)',
                      top: handle.includes('top') ? '-10px' : handle.includes('bottom') ? 'calc(100% - 10px)' : 'calc(50% - 10px)',
                      zIndex: 3,
                      touchAction: 'none'
                    }}
                    onMouseDown={handleResizeHandleMouseDown(handle)}
                    onTouchStart={handleResizeHandleMouseDown(handle)}
                  />
                ))}
              </div>
            </div>
            <Typography variant="body2" sx={{ fontSize: '14px', color: '#666', mb: 2, textAlign: 'center' }}>
              Arrastra el área de recorte para moverla o usa las esquinas para redimensionarla
            </Typography>
            <ArgonBox display="flex" gap={2} justifyContent="center">
              <Button
                onClick={handleCropCancel}
                disabled={isProcessingCrop}
                variant="outlined"
                sx={{
                  borderColor: '#555',
                  borderWidth: '1.5px',
                  color: '#1a1a1a',
                  backgroundColor: '#f5f5f5',
                  fontWeight: 600,
                  '&:hover': {
                    borderColor: '#333',
                    backgroundColor: '#e8e8e8',
                    color: '#000'
                  },
                  '&:disabled': {
                    borderColor: '#ccc',
                    color: '#999',
                    backgroundColor: '#fafafa'
                  }
                }}
              >
                Cancelar
              </Button>
              <Button
                onClick={handleCropAccept}
                disabled={isProcessingCrop}
                variant="contained"
                sx={{
                  backgroundColor: '#1976d2',
                  color: '#fff',
                  '&:hover': {
                    backgroundColor: '#1565c0'
                  },
                  '&:disabled': {
                    backgroundColor: '#90caf9',
                    color: '#fff'
                  }
                }}
              >
                {isProcessingCrop ? (
                  <ArgonBox display="flex" alignItems="center" gap={1}>
                    <div style={{
                      width: '16px',
                      height: '16px',
                      border: '2px solid #ffffff',
                      borderTop: '2px solid transparent',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite'
                    }}></div>
                    Procesando...
                  </ArgonBox>
                ) : 'Guardar'}
              </Button>
            </ArgonBox>
          </div>
        </div>
      )}

      {/* Popover de notificaciones */}
      <Popover
        open={Boolean(notificationsAnchorEl)}
        anchorEl={notificationsAnchorEl}
        onClose={handleNotificationsClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        sx={{
          zIndex: 9999,
          '& .MuiPopover-paper': {
            borderRadius: '8px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
            border: '1px solid #e0e0e0',
            backgroundColor: '#ffffff',
            minWidth: '200px',
            zIndex: 9999,
          }
        }}
      >
        <Box sx={{ p: 2, textAlign: 'center' }}>
          <Typography variant="body2" sx={{ color: '#666', fontSize: '14px' }}>
            No hay notificaciones pendientes
          </Typography>
        </Box>
      </Popover>

      {/* Estilos CSS personalizados */}
      <style jsx>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </>
  );
};

export default Perfil;
